import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import ProductCard from '@zenbusiness/dashboard-components/ProductCard';
import { PropTypes } from 'prop-types';

import { dataTrackingPropsType } from '#client/utils/reporting';
import { buildCartUrl } from '#client/utils/urls';

import { PRODUCT_CARD_STATUS } from '../utils/constants';

const PRODUCT = 'domain_name_reg';

const DomainProductCard = ({ isPurchased, onLearnMoreClick, dataTrackingProps }) => {
  const { businessEntityUuid } = useBusinessEntity();

  return (
    <ProductCard
      description="Registered web address that is attached to your business website."
      eventProps={dataTrackingProps}
      imageUrl="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/s2/vector/domain-name-registration.svg"
      status={isPurchased ? PRODUCT_CARD_STATUS.PURCHASED : null}
      primaryCta={{
        label: 'Learn more',
        modalName: PRODUCT
      }}
      secondaryCta={{
        label: isPurchased ? 'Add another' : 'Buy now',
        url: buildCartUrl(PRODUCT, { businessEntityUuid })
      }}
      title="Domain"
      onCtaClick={onLearnMoreClick}
    />
  );
};

DomainProductCard.propTypes = {
  isPurchased: PropTypes.bool.isRequired,
  onLearnMoreClick: PropTypes.func.isRequired,
  dataTrackingProps: dataTrackingPropsType
};

export default DomainProductCard;
